import { Container, Stack, Title, Text } from '@mantine/core';

export const PrivacyPage = () => {
  return (
    <Container my="xl" size="md">
      <Stack gap="md">
        <Title order={1}>OCHRANA A SPRACOVANIE OSOBNÝCH ÚDAJOV</Title>
        <Title order={2}>Čo sú osobné údaje?</Title>
        <Text>
          Osobným údajom sa rozumie akákoľvek informácia týkajúca sa určeného alebo
          identifikovateľného subjektu údajov. Subjekt údajov sa považuje za určený alebo
          identifikovateľný, ak možno subjekt údajov priamo alebo nepriamo identifikovať najmä na
          základe čísla, kódu alebo jedného či viacerých prvkov, špecifických pre jeho fyzickú,
          fyziologickú, psychickú, ekonomickú, kultúrnu alebo sociálnu identitu.
        </Text>

        <Text>
          Medzi osobné údaje teda spadajú najmä meno, priezvisko, adresa fyzickej osoby, e-mail, IP
          adresa, môžu nimi byť informácie o využívaní služieb alebo o činnostiach a preferenciách
          fyzickej osoby. Ochrana osobných údajov je upravená zákonom č. 18/2018 Z.z. o ochrane
          osobných údajov a o zmene a doplnení niektorých zákonov, v platnom znení (&quot;zákon o
          ochrane osobných údajov&quot;).
        </Text>
        <Title order={2}>Čo je spracovanie osobných údajov?</Title>
        <Text>
          Spracovaním osobných údajov sa rozumie akákoľvek operácia alebo súbor operácií, ktoré
          správca alebo spracovateľ systematicky vykonávajú s osobnými údajmi, a to automatizovane
          alebo inými prostriedkami, najmä zhromažďovanie, ukladanie na nosiče informácií,
          sprístupňovanie, úprava alebo zmena, vyhľadávanie, používanie, odovzdávanie, šírenie,
          zverejňovanie, uchovávanie, výmena, triedenie alebo kombinovanie, blokovanie a likvidácia.
        </Text>
        <Title order={2}>Kto je správca resp. spracovateľ osobných údajov?</Title>
        <Text>
          Sme spoločnosť Miroslava Gujdová, IČO 47780002, so sídlom Slovenská 6455/1A, 071 01
          Michalovce zapísaná v živnostenskom registri Okresného úradu Michalovce, číslo
          živnostenského registra: 840-21505.
        </Text>
        <Text>
          Vaše osobné údaje spracovávame ako správca, tj. určujeme, ako budú osobné údaje
          spracovávané a za akým účelom, ako dlho a vyberáme prípadne ďalších spracovateľov, ktorí
          nám so spracovaním budú pomáhať.
        </Text>

        <Title order={2}>Kontaktné údaje na zodpovednú osobu</Title>
        <Text>
          Pokiaľ sa na nás budete chcieť v priebehu spracovania údajov obrátiť s nejakými otázkami,
          môžete nás kontaktovať e-mailom na info@laskykrasky.sk.
        </Text>
        <Title order={2}>Rozsah osobných údajov a účely spracovania</Title>
        <Text>
          Spracovávame osobné údaje, ktoré nám zveríte sami, a to z nasledujúcich dôvodov (pre
          naplnenie týchto účelov):
        </Text>

        <Text>
          • poskytovanie služieb, plnenie zmluvy: Vaše osobné údaje v rozsahu: meno, priezvisko,
          e-mail, telefónne číslo, fakturačná a dodacia adresa, údaje o objednávke = nevyhnutne
          potrebujeme na vybavenie objednávky a doručenie tovaru prostredníctvom kuriérskej
          spoločnosti.
        </Text>

        <Text>
          • vedenie účtovníctva: Ak ste zákazníkom, Vaše osobné údaje (fakturačné údaje) nevyhnutne
          potrebujeme, aby sme vyhoveli zákonnej povinnosti pre vystavovanie a evidenciu daňových
          dokladov.
        </Text>

        <Text>
          Vaše osobné údaje si ponechávame po dobu premlčacích lehôt, pokiaľ zákon neustanovuje
          dlhšiu dobu k ich uchovaniu alebo sme v konkrétnych prípadoch neuviedli inak.
        </Text>
        <Title order={2}>Cookies</Title>
        <Text>
          Pri prechádzaní našich webových stránok zaznamenávame Vašu IP adresu, ako dlho sa na
          stránke zdržíte a z ktorej stránky prichádzate. Používanie cookies na meranie návštevnosti
          webu a prispôsobenie zobrazenia webových stránok vnímame ako svoj oprávnený záujem
          správcu, lebo veríme, že vďaka tomu Vám môžeme ponúknuť ešte lepšie služby.
        </Text>

        <Text>
          Cookies pre cielenie reklamy budú spracovávané len na základe Vášho súhlasu. Naše webové
          stránky môžete prechádzať aj v režime, ktorý neumožňuje zbieranie osobných údajov.
          Používanie cookies môžete na svojom počítači zakázať.
        </Text>

        <Title order={2}>Zabezpečenie a ochrana osobných údajov</Title>
        <Text>
          S Vašimi osobnými údajmi budeme nakladať zodpovedne a v súlade s platnou legislatívou. Pre
          spracovanie osobných údajov využívame automatizované aj neautomatizované prostriedky.
          Všetky údaje sú uložené na zabezpečených serveroch uložených výhradne v Európskej únii.
          Chránime osobné údaje v maximálnej možnej miere pomocou moderných technológií, ktoré
          zodpovedajú stupňu technického rozvoja.
        </Text>

        <Title order={2}>Poskytnutie osobných údajov tretím stranám</Title>
        <Text>
          K Vašim osobným údajom majú prístup naši zamestnanci a spolupracovníci. Pre zaistenie
          konkrétnych spracovateľských operácií, ktoré nedokážeme zabezpečiť vlastnými silami,
          využívame služby a aplikácie spracovateľov, ktorí vedia dáta ochrániť a na dané
          spracovanie dát sa špecializujú.
        </Text>

        <Title order={2}>Poskytnutie osobných údajov mimo EÚ</Title>
        <Text>Akékoľvek spracovanie osobných údajov bude uskutočnené výhradne na území EÚ.</Text>
        <Title order={2}>Vaše práva v súvislosti so spracovaním a ochranou osobných údajov</Title>
        <Text>
          V súvislosti s ochranou osobných údajov máte svoje práva. Ak budete chcieť niektoré z
          týchto práv využiť, prosím, kontaktujte nás prostredníctvom e-mailu: info@laskykrasky.sk.
        </Text>

        <Text>
          Máte právo na informácie, ktoré sú plnené už touto informačnou stránkou so zásadami
          spracovania osobných údajov.
        </Text>

        <Text>
          Vďaka právu na prístup nás môžete kedykoľvek vyzvať a my Vám doložíme v lehote 14 dní, aké
          Vaše osobné údaje spracovávame a prečo. Ak sa u Vás niečo zmení alebo akékoľvek svoje
          osobné údaje budete považovať za neaktuálne alebo neúplné, máte právo na doplnenie a zmenu
          osobných údajov.
        </Text>

        <Text>
          Právo na obmedzenie spracovania môžete využiť, ak sa domnievate, že spracovávame Vaše
          nepresné údaje, myslíte si, že vykonávame spracovanie nezákonne, ale nechcete všetky údaje
          zmazať, alebo ak ste vzniesli námietku proti spracovaniu. Obmedziť môžete rozsah osobných
          údajov alebo účelov spracovania. (Napr. odhlásením z newslettera obmedzujete účel
          spracovania pre zasielanie obchodných oznámení.)
        </Text>

        <Title order={2}>Právo na prenosnosť</Title>
        <Text>
          Ak by ste chceli svoje osobné údaje vziať a preniesť k niekomu inému, budeme postupovať
          rovnako ako pri využití práva na prístup - len s tým rozdielom, že Vám informácie dodáme /
          pošleme v strojovo čitateľnej podobe. Tu potrebujeme aspoň 30 dní.
        </Text>

        <Title order={2}>Právo na výmaz (byť zabudnutý)</Title>
        <Text>
          Vašim ďalším právom je právo na vymazanie (byť zabudnutý). V takom prípade vymažeme všetky
          Vaše osobné údaje z našich systémov aj zo systémov všetkých čiastkových spracovateľov a
          taktiež zo záloh. Na zabezpečenie práva na výmaz potrebujeme 14 dní.
        </Text>

        <Text>
          V niektorých prípadoch sme viazaní zákonnou povinnosťou a napr. musíme evidovať vystavené
          daňové doklady po lehotu stanovenú zákonom. V tomto prípade teda zmažeme všetky také
          osobné údaje, ktoré nie sú viazané iným zákonom. O dokončení výmazu Vás budeme informovať
          e-mailom.
        </Text>

        <Title order={2}>Sťažnosť na Úrade na ochranu osobných údajov</Title>
        <Text>
          Ak máte pocit, že s Vašimi údajmi nezaobchádzame v súlade so zákonom, máte právo sa so
          svojou sťažnosťou kedykoľvek obrátiť na Úrad pre ochranu osobných údajov. Budeme veľmi
          radi, pokiaľ najprv budete o tomto podozrení informovať nás, aby sme s tým mohli niečo
          urobiť a prípadné pochybenie napraviť.
        </Text>

        <Title order={2}>Odhlásenie zo zasielania newsletterov a obchodných oznámení</Title>
        <Text>
          E-maily s inšpiráciou, článkami či produktovými informáciami a službami Vám zasielame, ak
          ste náš zákazník, na základe nášho oprávneného záujmu. Ak zákazníkom ešte nie ste,
          posielame Vám e-maily len na základe Vášho súhlasu. V oboch prípadoch môžete ukončiť odber
          našich e-mailov kliknutím na odhlasovací odkaz v každej zaslanej e-mailovej správe.
        </Text>

        <Title order={2}>Mlčanlivosť</Title>
        <Text>
          Dovoľujeme si Vás uistiť, že naši zamestnanci aj spolupracovníci, ktorí budú spracovávať
          Vaše osobné údaje, sú povinní zachovávať mlčanlivosť o osobných údajoch a o bezpečnostných
          opatreniach, ktorých zverejnenie by ohrozilo bezpečnosť Vašich osobných údajov. Táto
          mlčanlivosť pritom trvá aj po skončení záväzkových vzťahov s nami. Bez Vášho súhlasu
          nebudú Vaše osobné údaje vydané žiadnej inej tretej strane.
        </Text>

        <Text>Tieto zásady spracovania osobných údajov platia od 10.12.2022.</Text>
      </Stack>
    </Container>
  );
};
